import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="bg-black text-white min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-4xl font-bold text-center text-orange-500 mb-6">Privacy Policy</h1>
        <p className="text-gray-400 text-center text-lg">Effective Date: <span className="text-orange-500">01/01/2025</span> | Last Updated: <span className="text-orange-500">01/01/2025</span></p>

        <div className="mt-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Introduction</h2>
            <p className="text-gray-300">
              Welcome to <span className="text-orange-500">infuber.com</span> (“we,” “our,” or “us”). This Privacy Policy explains how we collect, use, and protect your personal data when you use our platform, including logging in with <span className="text-orange-500">Instagram</span>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Information We Collect</h2>
            <ul className="list-disc ml-6 text-gray-300 space-y-2">
              <li><span className="text-orange-500">Instagram Profile Information:</span> Name</li>
              <li><span className="text-orange-500">Email Address:</span> If shared by Instagram</li>
              <li><span className="text-orange-500">Follower & Engagement Data:</span> To provide insights on influencer reach</li>
              <li><span className="text-orange-500">Public Content:</span> Posts, Stories, and media as permitted by Instagram API</li>
              <li><span className="text-orange-500">Device & Usage Information:</span> Interactions with our platform</li>
            </ul>
            <p className="text-gray-300">
              We do <span className="text-orange-500">not</span> collect your Instagram password. Authentication is handled by Instagram’s OAuth system.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500"> How We Use Your Information</h2>
            <ul className="list-disc ml-6 text-gray-300 space-y-2">
              <li>Authenticate your login and manage your profile</li>
              <li>Provide influencer analytics and engagement insights</li>
              <li>Improve platform features and user experience</li>
              <li>Offer customer support and respond to inquiries</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Data Sharing & Third-Party Services</h2>
            <p className="text-gray-300">
              We do <span className="text-orange-500">not</span> sell or rent your data. However, we may share information with:
            </p>
            <ul className="list-disc ml-6 text-gray-300 space-y-2">
              <li><span className="text-orange-500">Instagram API:</span> To fetch necessary influencer data</li>
              <li><span className="text-orange-500">Service Providers:</span> Hosting, analytics, and app performance tools</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Data Security & Retention</h2>
            <p className="text-gray-300">
              We store your data securely using <span className="text-orange-500">industry-standard encryption</span>. Your information is retained only as long as necessary for platform functionality. You can request data deletion anytime by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Your Rights & Choices</h2>
            <ul className="list-disc ml-6 text-gray-300 space-y-2">
              <li><span className="text-orange-500">Revoke Permissions:</span> Manage app access in Instagram settings.</li>
              <li><span className="text-orange-500">Access & Correct Data:</span> Contact us to review your information.</li>
              <li><span className="text-orange-500">Request Data Deletion:</span> Send a request to <span className="text-orange-500">help@infuber.com</span>.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Cookies & Tracking Technologies</h2>
            <p className="text-gray-300">
              We may use <span className="text-orange-500">cookies and similar technologies</span> to enhance your experience. You can manage cookie preferences in your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Changes to This Policy</h2>
            <p className="text-gray-300">
              We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-orange-500">Contact Us</h2>
            <p className="text-gray-300">For any privacy-related questions or concerns, contact us at:</p>
            <p className="text-gray-300 font-semibold">📧 Email: <span className="text-orange-500">help@infuber.com</span></p>
            <p className="text-gray-300 font-semibold">🌐 Website: <span className="text-orange-500">infuber.com</span></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;